import { render, staticRenderFns } from "./ModifyIonlineSimsPackageModal.vue?vue&type=template&id=5228be83&scoped=true&"
import script from "./ModifyIonlineSimsPackageModal.vue?vue&type=script&lang=js&"
export * from "./ModifyIonlineSimsPackageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5228be83",
  null
  
)

export default component.exports